import { Helmet } from "react-helmet";
import { forwardRef } from "react";
// material
import { Box, BoxProps } from "@mui/material";

// ----------------------------------------------------------------------

type Props = BoxProps & { title: string };
const Page = forwardRef<HTMLDivElement, Props>(({ children, title = "", ...other }, ref) => {
  return (
    <Box ref={ref} {...other}>
      <Helmet>
        <title>{title} | BARQ</title>
      </Helmet>
      {children}
    </Box>
  );
});

export default Page;
